if (!customElements.get('norella-sticky-purchase')) {
  customElements.define('norella-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.purchase = document.getElementById(this.dataset.observe);
      if (!this.purchase || this.listeners) return;
      this.listeners = new AbortController();
      const update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.hidden = this.purchase.getBoundingClientRect().bottom >= 0;
        });
      };
      window.addEventListener('scroll', update, { passive: true, signal: this.listeners.signal });
      window.addEventListener('resize', update, { passive: true, signal: this.listeners.signal });
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.purchase);
      update();
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.listeners = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
